import React from "react";

const Input = ({
  element,
  type,
  placeHolder,
  label,
  labelClass,
  className,
  register,
  value,
  radioLabel,
  id,
  error,
  name,
  check,
  onChange,
  disabled,
  wrapperClass,
  onKeyDown,
  tooltip,
  min,
  max,
  style,
  onBlur,
  errorText,
}) => {
  let input;

  if (element === "input") {
    input = label ? (
      <div
        className={`${wrapperClass} !font-[YekanBakh] w-full flex flex-col gap-2`}
      >
        {tooltip ? (
          <div className="flex items-center gap-1">
            <label className={`${labelClass} text-gray-200`}>{label}</label>

            <div className="relative group">
              <div className="absolute group-hover:opacity-100 opacity-0 transition-all duration-300 left-2/4 -translate-x-2/4 bg-gray-700 rounded-lg text-white py-[2px] px-3 text-sm -top-[28px]">
                تست
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-4 h-4 stroke-gray-600"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
                />
              </svg>
            </div>
          </div>
        ) : (
          <label className={`${labelClass} text-gray-200`}>{label}</label>
        )}
        <input
          type={type}
          style={style}
          placeholder={placeHolder}
          className={`${className} ${
            error
              ? "ring-1 ring-red-600 focus:ring-red-600 bg-[#222222]"
              : "focus:ring-yellow-700 bg-[#222222]"
          } w-full h-[50px] rounded-xl px-4 outline-none text-gray-200 focus:ring-2 focus:shadow-lg border border-gray-800 transition-all duration-200`}
          {...register}
          value={value}
          disabled={disabled}
          // onChange={onChange}
          min={min ? min : 0}
          max={max ? max : 1000000}
        />

        {error || errorText ? (
          <span className="text-red-600 text-sm">
            {errorText ? errorText : error[0]}
          </span>
        ):""}
      </div>
    ) : (
      <div
        className={`${wrapperClass} !font-[YekanBakh] w-full flex flex-col gap-2`}
      >
        <input
          onKeyDown={onKeyDown}
          onBlur={onBlur}
          type={type}
          placeholder={placeHolder}
          className={`${className} ${
            error
              ? "ring-1 ring-red-600 focus:ring-red-600 bg-[#222222]"
              : "focus:ring-yellow-700 bg-[#222222]"
          } w-full h-[50px] rounded-xl px-4 outline-none text-gray-200 focus:ring-2 focus:shadow-lg border border-gray-800 transition-all duration-200`}
          value={value}
          onChange={onChange}
          disabled={disabled}
        />

        {error && <span className="text-red-600 text-sm">{error[0]}</span>}
      </div>
    );
    // radio button
  } else if (element === "radio") {
    input = label ? (
      <div className="!font-[YekanBakh] w-full flex flex-col gap-2">
        <label className="font-semibold text-slate-600">{label}</label>

        <div className="w-full gender-radio">
          <input
            type="radio"
            className="peer"
            id={id}
            value={value}
            {...register}
          />
          <label
            className={`${labelClass} cursor-pointer w-28 h-11 px-3 pr-10 rounded-xl`}
            htmlFor={id}
          >
            {radioLabel}
          </label>
        </div>
      </div>
    ) : (
      <div className="w-full gender-radio">
        <input
          type="radio"
          className="peer"
          id={id}
          value={value}
          {...register}
          onChange={onChange}
          defaultChecked={check ? true : false}
        />
        <label
          className={`${labelClass} cursor-pointer w-28 h-11 px-3 pr-10 rounded-xl`}
          htmlFor={id}
        >
          {radioLabel}
        </label>
      </div>
    );
  } else {
    // text area
    input = (
      <div
        className={`${wrapperClass} !font-[YekanBakh] w-full flex flex-col gap-2`}
      >
        <label className={`${labelClass} text-gray-200`}>{label}</label>

        <textarea
          placeholder={placeHolder}
          {...register}
          value={value}
          className={`${className} ${
            error
              ? "ring-1 ring-red-600 bg-transparent focus:ring-red-600"
              : "focus:ring-yellow-700 bg-[#222222]"
          } w-full h-full rounded-xl p-4 outline-none text-gray-200 focus:ring-2 focus:shadow-lg border border-gray-800 transition-all duration-200`}
        ></textarea>
        {error && <span className="text-red-600 text-sm">{error[0]}</span>}
      </div>
    );
  }

  return input;
};

export default Input;
